import { render } from "./Add.vue?vue&type=template&id=437e7c1a"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import exportComponent from "/home/stagingfloretcollegein/staging.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__